import React, { useState, useRef, useEffect, useCallback } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import { Location } from '../types/chat';
import { MapUpdater } from './map/MapUpdater';
import { MapInfoCard } from './MapInfoCard';
import { MarkerTooltip } from './MarkerTooltip';
import 'leaflet/dist/leaflet.css';

import { mapStateService } from '../services/dataPersistence';

import { CarouselControls } from './CarouselControl';
import { findPlace, getPlacePhotos } from '../services/places';

import { createPin, COLOR_SEQUENCE } from '../utils/markerUtils';
import { X, ChevronLeft, ChevronRight, MapPin, Star, Landmark, Building, Castle, MenuIcon as Monument, Church, Replace as Palace, Mouse as Museum, Mountain, Trees as Tree, Palmtree, Tent, Warehouse, UtensilsCrossed, Waves, Umbrella, Flower2, Camera, Wine, Coffee, ShoppingBag, Ticket } from 'lucide-react';


/* interface MapPanelProps {
  view: 'osm' | 'google';
  locations: Location[];
  onLocationSelect: (location: Location | null) => void;
  isLoading: boolean;
  isStreaming: boolean;
  selectedLocation?: Location | null;
  isProcessingLocation?: boolean;
} */

/* interface MapPanelProps {
  view: 'osm' | 'google';
  locations: Location[];
  onLocationSelect: (location: Location | null) => void;
  isLoading: boolean;
  isStreaming: boolean;
  selectedLocation: Location | null;
  isProcessingLocation: boolean;
  showPopupForSelected?: boolean; // Add this line
  chatPanelVisible?: boolean;
} */

interface MapPanelProps {
  view: 'osm' | 'google';
  locations: Location[];
  onLocationSelect: (location: Location | null) => void;
  isLoading: boolean;
  isStreaming: boolean;
  selectedLocation: Location | null;
  isProcessingLocation: boolean;
  showPopupForSelected?: boolean;
  chatPanelVisible?: boolean; // Add this line
  chatPanelRef?: React.RefObject<HTMLDivElement>; // Optional ref to chat panel
}


// New component to handle all map controls
/* const MapControls: React.FC<{
  locations: Location[];
  onReset: () => void;
  chatPanelVisible: boolean;
}> = ({ locations, onReset, chatPanelVisible }) => {    
  const map = useMap();
  return (
    <div className={`absolute top-4 transition-all duration-300 ease-in-out z-[1000] ${
      chatPanelVisible ? 'left-[416px]' : 'left-4'
    }`}>
      <div className="flex flex-col gap-2">
        <div className="bg-white rounded-lg shadow-md flex flex-col">
          <button 
            onClick={() => map.zoomIn()}
            className="p-2 hover:bg-gray-100 rounded-t-lg"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
          </button>
          <div className="h-px bg-gray-200"></div>
          <button 
            onClick={() => map.zoomOut()}
            className="p-2 hover:bg-gray-100 rounded-b-lg"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
          </button>
        </div>
        
        <button
          onClick={onReset}
          className="bg-white rounded-lg shadow-md px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          Reset View
        </button>
      </div>
    </div>
  );
}; */
/* const MapControls = ({ locations, onReset, chatPanelVisible }) => {
  const map = useMap();
  
  return (
    <div 
      className="fixed top-20 transition-all duration-300 ease-in-out"
      style={{
        left: chatPanelVisible ? '420px' : '20px',
        zIndex: 9999
      }}
    >
      <div className="flex flex-col gap-2">
        <div className="bg-white rounded-lg shadow-md flex flex-col">
          <button 
            onClick={() => map.zoomIn()}
            className="p-2 hover:bg-gray-100 rounded-t-lg"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
          </button>
          <div className="h-px bg-gray-200"></div>
          <button 
            onClick={() => map.zoomOut()}
            className="p-2 hover:bg-gray-100 rounded-b-lg"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
          </button>
        </div>
        
        <button
          onClick={onReset}
          className="bg-white rounded-lg shadow-md px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          Reset View
        </button>
      </div>
    </div>
  );
}; */
/* const ResetControl: React.FC<{ locations: Location[]; onReset: () => void; chatPanelVisible?: boolean;}> = ({ 
  locations, 
  onReset,
  chatPanelVisible = true 
}) => {
  const map = useMap();
  
  const handleReset = () => {
    if (locations.length === 0) return;
    
    const bounds = locations.reduce((bounds, location) => {
      bounds.extend([location.position.lat, location.position.lng]);
      return bounds;
    }, map.getBounds());
    
    map.flyToBounds(bounds.pad(0.2), {
      duration: 2,
      easeLinearity: 0.25
    });

    onReset();
  };

  return (
    <div className={`leaflet-top leaflet-left transition-all duration-300 ${
      chatPanelVisible ? 'ml-[400px]' : 'ml-4'
    }`}>
      <div className="leaflet-control">
        <button
          onClick={handleReset}
          className="bg-white rounded-lg shadow-md px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-transform duration-300"
        >
          Reset View
        </button>
      </div>
    </div>
  );
}; */

export const MapPanel: React.FC<MapPanelProps> = ({ 
  view,
  locations,  
  onLocationSelect,
  isLoading,
  isStreaming,
  selectedLocation,
  isProcessingLocation = false,
  showPopupForSelected = false,
  chatPanelVisible = true // Add this line with default
}) => {

  // Add this at the top of the MapPanel component
  const prevSelectedLocationRef = useRef(selectedLocation);

  const [locationImages, setLocationImages] = useState<string[]>([]);

  // Handler function
  const handleImagesUpdate = (newImages: string[]) => {
    //console.log('[MapPanel] Images updated from child component:', newImages.length);
    setLocationImages(newImages);
  };

  const [showInfoCard, setShowInfoCard] = useState(false);
  const [selectedMarkerLocation, setSelectedMarkerLocation] = useState<Location | null>(null);
  // Move the useState hook inside the component
  const [markerPosition, setMarkerPosition] = useState<{ x: number, y: number } | null>(null);
  const mapRef = useRef<L.Map | null>(null);

  const validLocations = locations.filter(loc => 
    loc.position && 
    !isNaN(loc.position.lat) && 
    !isNaN(loc.position.lng) &&
    loc.position.lat >= -90 && 
    loc.position.lat <= 90 &&
    loc.position.lng >= -180 && 
    loc.position.lng <= 180
  );

  const [carouselImages, setCarouselImages] = useState<string[]>([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isLoadingImages, setIsLoadingImages] = useState(false);


  const [isMapAnimating, setIsMapAnimating] = useState(false);
  const [activeMarkerId, setActiveMarkerId] = useState<string | null>(null);
  const [hoveredMarkerId, setHoveredMarkerId] = useState<string | null>(null);
  const markerRefs = useRef<{[id: string]: L.Marker}>({});

  const [popupImages, setPopupImages] = useState<string[]>([]);

  // At the top of MapPanel with other state variables
  const [newMarkerIds, setNewMarkerIds] = useState<Set<string>>(new Set());
  const [isClosing, setIsClosing] = useState(false);
  const [hoverSource, setHoverSource] = useState<'map' | 'card' | null>(null);
  // Add these state variables to the MapPanel component
  const [tooltipPosition, setTooltipPosition] = useState<{ x: number, y: number } | null>(null);
  const [hoveredLocation, setHoveredLocation] = useState<Location | null>(null);

  /* // Add a function to handle Google Maps link
  const handleMapsClick = async (location: Location, e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    
    try {
      const mapsUrl = await findPlace(location);
      window.open(mapsUrl, '_blank');
    } catch (error) {
      // console.error('[MapPanel] Error opening maps:', error);
    }
  }; */

  // Get appropriate icon based on location name/description
  const getLocationIcon = () => {
    if (!location) return null;
    
    const nameAndDesc = (location.name + ' ' + (location.description || '')).toLowerCase();
    
    // Religious/Cultural sites
    if (nameAndDesc.includes('temple') || nameAndDesc.includes('shrine') || nameAndDesc.includes('church')) {
      return <Church className="w-12 h-12 text-amber-600" />;
    }
    
    // Historical buildings
    if (nameAndDesc.includes('castle') || nameAndDesc.includes('fort')) {
      return <Castle className="w-12 h-12 text-stone-600" />;
    }
    if (nameAndDesc.includes('palace')) {
      return <Palace className="w-12 h-12 text-purple-600" />;
    }
    if (nameAndDesc.includes('monument') || nameAndDesc.includes('memorial')) {
      return <Monument className="w-12 h-12 text-gray-600" />;
    }
    
    // Cultural institutions
    if (nameAndDesc.includes('museum')) {
      return <Museum className="w-12 h-12 text-blue-600" />;
    }
    if (nameAndDesc.includes('theater') || nameAndDesc.includes('theatre') || nameAndDesc.includes('opera')) {
      return <Ticket className="w-12 h-12 text-rose-600" />;
    }
    
    // Nature
    if (nameAndDesc.includes('mountain') || nameAndDesc.includes('peak') || nameAndDesc.includes('hill')) {
      return <Mountain className="w-12 h-12 text-emerald-700" />;
    }
    if (nameAndDesc.includes('forest') || nameAndDesc.includes('park') || nameAndDesc.includes('garden')) {
      return <Tree className="w-12 h-12 text-green-600" />;
    }
    if (nameAndDesc.includes('beach') || nameAndDesc.includes('coast')) {
      return <Palmtree className="w-12 h-12 text-orange-500" />;
    }
    if (nameAndDesc.includes('lake') || nameAndDesc.includes('river') || nameAndDesc.includes('waterfall')) {
      return <Waves className="w-12 h-12 text-blue-500" />;
    }
    
    // Recreation
    if (nameAndDesc.includes('camp') || nameAndDesc.includes('national park')) {
      return <Tent className="w-12 h-12 text-green-700" />;
    }
    if (nameAndDesc.includes('farm') || nameAndDesc.includes('vineyard') || nameAndDesc.includes('ranch')) {
      return <Flower2 className="w-12 h-12 text-green-500" />;
    }
    if (nameAndDesc.includes('viewpoint') || nameAndDesc.includes('lookout')) {
      return <Camera className="w-12 h-12 text-indigo-500" />;
    }
    
    // Urban attractions
    if (nameAndDesc.includes('restaurant') || nameAndDesc.includes('dining')) {
      return <UtensilsCrossed className="w-12 h-12 text-red-500" />;
    }
    if (nameAndDesc.includes('cafe') || nameAndDesc.includes('coffee')) {
      return <Coffee className="w-12 h-12 text-amber-700" />;
    }
    if (nameAndDesc.includes('bar') || nameAndDesc.includes('pub')) {
      return <Wine className="w-12 h-12 text-purple-500" />;
    }
    if (nameAndDesc.includes('market') || nameAndDesc.includes('shopping')) {
      return <ShoppingBag className="w-12 h-12 text-pink-500" />;
    }
    if (nameAndDesc.includes('building') || nameAndDesc.includes('tower')) {
      return <Building className="w-12 h-12 text-indigo-600" />;
    }
    
    // Beach amenities
    if (nameAndDesc.includes('beach club') || nameAndDesc.includes('resort')) {
      return <Umbrella className="w-12 h-12 text-cyan-500" />;
    }
    
    // Default icon
    return <Landmark className="w-12 h-12 text-teal-600" />;
  };  

  const defaultCenter: [number, number] = [20, 0];
  const defaultZoom = 2.5;

  const tileLayer = view === 'osm' ? (
    <TileLayer
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    />
  ) : (
    <TileLayer
      url="https://mt.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
      maxZoom={20}
      attribution='&copy; <a href="https://www.google.com/maps">Google Maps</a>'
    />
  );


/*   const fetchPlaceImages = async (location: Location) => {
    setIsLoadingImages(true);
    try {
      console.log('[MapPanel] Fetching images for:', location.name);
      const result = await getPlacePhotos(location);
      
      // Ensure we have valid URLs
      const validPhotos = result.photos.filter(url => url && url.trim() !== '');
      
      // OPTIONAL: Limit to 5 images maximum for better UI performance
      const limitedPhotos = validPhotos.slice(0, 5);
      
      // Set the images
      setPopupImages(limitedPhotos.length > 0 ? limitedPhotos : ['/placeholder-image.png']);
      
      // Update location description if available and not already set
      if (result.description && (!location.description || location.description === 'No description')) {
        const updatedLocation = {
          ...location,
          description: result.description
        };
        setSelectedMarkerLocation(updatedLocation);
      }
    } catch (error) {
      console.error('[MapPanel] Error fetching place images:', error);
      setPopupImages(['/placeholder-image.png']);
    } finally {
      setIsLoadingImages(false);
    }
  }; */

  const fetchPlaceImages = async (location: Location) => {
    console.log('[MapPanel] Fetching images for:', location.name);
    if (!location) return;
    
    // Clear existing images and set loading state
    setLocationImages([]);
    setIsLoadingImages(true);
    
    try {
      //console.log('[MapPanel] Fetching images for:', location.name);
      
      try {
        // Get photos using the improved places service
        const result = await getPlacePhotos(location);
        
        // Ensure we have valid URLs
        const validPhotos = result.photos.filter(url => 
          typeof url === 'string' && url.trim() !== ''
        );
        
        //console.log(`[MapPanel] Loaded ${validPhotos.length} images for ${location.name}`);
        
        // Update the images state
        if (validPhotos.length > 0) {
          setLocationImages(validPhotos);
        } else {
          // Use fallback if no valid photos
          setLocationImages(['/placeholder-image.png']);
        }
        
        // Update location description if available and not already set
        if (result.description && (!location.description || location.description === 'No description')) {
          const updatedLocation = {
            ...location,
            description: result.description
          };
          // Update the location with the new description
          setSelectedMarkerLocation(updatedLocation);
        }
      } catch (error) {
        console.error('[MapPanel] Error fetching place images, using fallback:', error);
        setLocationImages(['/placeholder-image.png']);
      }
    } finally {
      setIsLoadingImages(false);
    }
  };
  
  // Add this function to get the correct marker position
  const getMarkerScreenPosition = (location: Location) => {
    if (!mapRef.current || !location) return null;
    
    const map = mapRef.current;
    
    try {
      // Get the marker's position in map container coordinates
      const latLng = L.latLng(location.position.lat, location.position.lng);
      const point = map.latLngToContainerPoint(latLng);
      
      // Return the coordinates
      return { x: point.x, y: point.y };
    } catch (error) {
      // console.error('[MapPanel] Error calculating marker position:', error);
      return null;
    }
  };

  // Example for Google Maps:
  const handleMapChange = useCallback(() => {
    if (mapRef.current) {
      
      /* const center = mapRef.current.getCenter();
      const zoom = mapRef.current.getZoom();
      
      if (center && zoom) {
        // Update map state
        mapStateService.updateMapState({
          center: {
            lat: center.lat(),
            lng: center.lng()
          },
          zoom: zoom
        });
      } */
    } 
  }, [mapRef]);

  // For handling selection, update your onLocationSelect handler:
  const handleLocationSelect = useCallback((location: Location | null) => {
    // Call original handler
    onLocationSelect(location);
    
    // Update map state with selected location
    if (location) {
      mapStateService.setSelectedLocation(location.id);
    } else {
      mapStateService.setSelectedLocation(null);
    }
  }, [onLocationSelect]);

  // Update handleMarkerClick in MapPanel.tsx
  // Fixed handleMarkerClick that clears old images immediately


/*   const handleMarkerClick = (location: Location, event: any) => {
    console.log('[MapPanel] Marker clicked:', location.name);
    
    // IMPORTANT: Clear previous images immediately to prevent showing old images
    setPopupImages([]);
    
    // Reset carousel and prep for images
    setCurrentImageIndex(0);
    
    // Show loading state
    setIsLoadingImages(true);
    
    // Get the initial position with correct anchor point
    if (mapRef.current) {
      const map = mapRef.current;
      
      // Get marker position
      const markerElement = event.sourceTarget._icon;
      if (markerElement) {
        const markerRect = markerElement.getBoundingClientRect();
        const mapRect = map.getContainer().getBoundingClientRect();
        
        // Calculate position relative to the map container
        // We want the popup to appear from the top center of the marker
        const x = markerRect.left + (markerRect.width / 2) - mapRect.left;
        
        // Y position should be at the top of the marker (minus a small offset)
        const y = markerRect.top - mapRect.top;
        
        // Set position
        setMarkerPosition({ x, y });
      } else {
        // Fallback calculation
        const latLng = L.latLng(location.position.lat, location.position.lng);
        const point = map.latLngToContainerPoint(latLng);
        setMarkerPosition({ x: point.x, y: point.y });
      }
    }
    
    // Update state before fetching images
    setSelectedMarkerLocation(location);
    setShowInfoCard(true);
    onLocationSelect(location);
    
    // Fetch images after state updates
    fetchPlaceImages(location);
  } */

  // Use it within handleMarkerClick like this:
  /* const handleMarkerClick = (location: Location, event: any) => {
    console.log('[MapPanel] Marker clicked:', location.name);
    
    // IMPORTANT: Clear previous images immediately to prevent showing old images
    setLocationImages([]);
    
    // Get marker position...
    
    // Update state before fetching images
    setSelectedMarkerLocation(location);
    setShowInfoCard(true);
    onLocationSelect(location);
    
    // Fetch images safely
    try {
      fetchPlaceImages(location);
    } catch (error) {
      console.error('[MapPanel] Error in fetchPlaceImages:', error);
      // Show info card even if image fetching fails
      setIsLoadingImages(false);
      setLocationImages(['/placeholder-image.png']);
    }
  }; */  

  // In MapPanel.tsx, update the handleMarkerClick function to explicitly set showInfoCard
/*   const handleMarkerClick = (location: Location, event: any) => {
    console.log('[MapPanel] Marker clicked:', location.name);
    
    // IMPORTANT: Clear previous images immediately to prevent showing old images
    setLocationImages([]);
    
    // CRITICAL: Explicitly set showInfoCard to true
    setShowInfoCard(true);
    
    // Reset isClosing flag if it was previously set
    setIsClosing(false);
    
    // Get marker position...
    
    // Update state
    setSelectedMarkerLocation(location);
    onLocationSelect(location);
    
    // Fetch images
    fetchPlaceImages(location);
  }; */

  // Updated handleMarkerClick
  const handleMarkerClick = (location: Location, event: any) => {
    //console.log('[MapPanel] Marker clicked:', location.name);
    
    // Stop any closing animation in progress
    setIsClosing(false);
    
    // IMPORTANT: Clear previous images immediately to prevent showing old images
    setLocationImages([]);
    
    // Get the marker position (keep your existing code here)
    if (mapRef.current) {
      const map = mapRef.current;
      
      // Get marker position
      const markerElement = event.sourceTarget._icon;
      if (markerElement) {
        const markerRect = markerElement.getBoundingClientRect();
        const mapRect = map.getContainer().getBoundingClientRect();
        
        // Calculate position relative to the map container
        const x = markerRect.left + (markerRect.width / 2) - mapRect.left;
        const y = markerRect.top - mapRect.top - 30;
        
        // Set position
        setMarkerPosition({ x, y });
      } else {
        // Fallback calculation
        const latLng = L.latLng(location.position.lat, location.position.lng);
        const point = map.latLngToContainerPoint(latLng);
        setMarkerPosition({ x: point.x, y: point.y });
      }
    }
    
    // Explicitly set visibility AFTER setting position
    setSelectedMarkerLocation(location);
    
    // CRITICAL: Force card to show with a slight delay to ensure position is set first
    setTimeout(() => {
      setShowInfoCard(true);
    }, 10);
    
    onLocationSelect(location);
    
    // Fetch images after state updates
    fetchPlaceImages(location);
  };
  /* const handleCloseInfoCard = () => {
    console.log('[MapPanel] Closing info card');
    setIsClosing(true);
    setShowInfoCard(false);
    
    // Use setTimeout to ensure animation completes before fully resetting state
    setTimeout(() => {
      setSelectedMarkerLocation(null);
      setMarkerPosition(null);
      setLocationImages([]); 
      onLocationSelect(null);
      setIsClosing(false); // Reset the closing state when done
    }, 150); // Match the transition duration
  }; */

  // Updated handleCloseInfoCard function
  /* const handleCloseInfoCard = () => {
    console.log('[MapPanel] Closing info card');
    setIsClosing(true);
    
    // Keep showInfoCard true until animation completes
    setTimeout(() => {
      setShowInfoCard(false);
      setSelectedMarkerLocation(null);
      setMarkerPosition(null);
      setLocationImages([]);
      onLocationSelect(null);
      
      // Important: Reset isClosing state
      setIsClosing(false);
      
      console.log('[MapPanel] Info card fully closed and reset');
    }, 150); // Match animation duration
  }; */

  /* // In MapPanel.tsx, modify the map click handler
  const handleMapClick = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    // Don't close if clicking on the info card or its children
    const target = e.target as HTMLElement;
    
    // Skip if clicked in info card or buttons
    if (target.closest('.map-info-card') || 
        target.closest('button') ||
        target.nodeName === 'BUTTON') {
      return;
    }
    
    // Close info card when clicking elsewhere on the map
    handleCloseInfoCard();
  }, [handleCloseInfoCard]); */

  const handleCloseInfoCard = () => {
    //console.log('[MapPanel] Closing info card');
    setIsClosing(true);
    
    // Keep showInfoCard true until animation completes
    setTimeout(() => {
      setShowInfoCard(false);
      setSelectedMarkerLocation(null);
      setMarkerPosition(null);
      setLocationImages([]);
      onLocationSelect(null);
      
      // Important: Reset isClosing state
      setIsClosing(false);
      
      // CRITICAL: Reset marker active state to return to default scale
      setActiveMarkerId(null);
      
      console.log('[MapPanel] Info card fully closed and reset');
    }, 150); // Match animation duration
  };
  
  
  // Add this improved handleMapClick function
  const handleMapClick = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    // Check if we're clicking on a marker or the info card (or its children)
    const target = e.target as HTMLElement;
    
    // Skip close action if clicking on:
    if (
      // Info card or its children
      target.closest('.map-info-card') || 
      // Marker icons
      target.closest('.leaflet-marker-icon') ||
      // Any buttons
      target.closest('button') ||
      target.tagName.toLowerCase() === 'button' ||
      // Any image elements
      target.tagName.toLowerCase() === 'img'
    ) {
      //console.log('[MapPanel] Clicked on excluded element, keeping info card open');
      return;
    }
    
    //console.log('[MapPanel] Map clicked, closing info card');
    handleCloseInfoCard();
  }, []);


  // Add event listeners for hover events from location cards
 /*  useEffect(() => {
    const handleLocationHover = (e: Event) => {
      const customEvent = e as CustomEvent;
      const locationId = customEvent.detail?.locationId;
      if (locationId) {
        setHoveredMarkerId(locationId);
      }
    };
    
    const handleLocationHoverEnd = () => {
      setHoveredMarkerId(null);
    };
    
    window.addEventListener('tripper-location-hover', handleLocationHover);
    window.addEventListener('tripper-location-hover-end', handleLocationHoverEnd);
    
    return () => {
      window.removeEventListener('tripper-location-hover', handleLocationHover);
      window.removeEventListener('tripper-location-hover-end', handleLocationHoverEnd);
    };
  }, []); */


  // Inside your MapPanel component:
  useEffect(() => {
    // Add style to head
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes markerPop {
        0% { transform: translate3d(0,0,0) scale(0); opacity: 0; }
        60% { transform: translate3d(0,0,0) scale(1.4); opacity: 1; }
        100% { transform: translate3d(0,0,0) scale(1); opacity: 1; }
      }
      
      .marker-pop {
        animation: markerPop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards !important;
      }
    `;
    document.head.appendChild(style);
    
    // Correct cleanup function
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  useEffect(() => {
    // Apply animation to new markers
    newMarkerIds.forEach(id => {
      const marker = markerRefs.current[id];
      if (marker) {
        const icon = (marker as any)._icon;
        if (icon) {
          // Clear any existing animation
          icon.classList.remove('marker-pop');
          // Force reflow
          void icon.offsetWidth;
          // Add animation
          icon.classList.add('marker-pop');
        }
      }
    });
  }, [newMarkerIds]);

  // Add this useEffect to update marker tooltip position when needed
  useEffect(() => {
    if (!mapRef.current || !hoveredLocation || showInfoCard) {
      // Hide tooltip when info card is shown or when no hovered location
      setTooltipPosition(null);
      return;
    }
    
    const updateTooltipPosition = () => {
      if (!hoveredLocation) return;
      
      try {
        const map = mapRef.current;
        if (!map) return;
        
        // Get the marker's position
        const latLng = L.latLng(hoveredLocation.position.lat, hoveredLocation.position.lng);
        const point = map.latLngToContainerPoint(latLng);
        
        // Set the tooltip position
        setTooltipPosition({ x: point.x, y: point.y });
      } catch (error) {
        console.error('[MapPanel] Error updating tooltip position:', error);
        setTooltipPosition(null);
      }
    };
    
    // Update position immediately
    updateTooltipPosition();
    
    // Update position on map movements
    const map = mapRef.current;
    map.on('move', updateTooltipPosition);
    map.on('zoom', updateTooltipPosition);
    
    return () => {
      map.off('move', updateTooltipPosition);
      map.off('zoom', updateTooltipPosition);
    };
  }, [hoveredLocation, showInfoCard]);

  // In the useEffect section of MapPanel
  useEffect(() => {
    const handleZoomIn = () => {
      if (mapRef.current) {
        const currentZoom = mapRef.current.getZoom();
        mapRef.current.setZoom(currentZoom + 1);
      }
    };
    
    const handleZoomOut = () => {
      if (mapRef.current) {
        const currentZoom = mapRef.current.getZoom();
        mapRef.current.setZoom(currentZoom - 1);
      }
    };
    
    window.addEventListener('map-zoom-in', handleZoomIn);
    window.addEventListener('map-zoom-out', handleZoomOut);
    
    return () => {
      window.removeEventListener('map-zoom-in', handleZoomIn);
      window.removeEventListener('map-zoom-out', handleZoomOut);
    };
  }, [mapRef.current]);

  useEffect(() => {
    const handleResetView = () => {
      if (mapRef.current && validLocations.length > 0) {
        const bounds = new L.LatLngBounds(
          validLocations.map(loc => [loc.position.lat, loc.position.lng])
        );
        mapRef.current.flyToBounds(bounds.pad(0.2));
      }
    };
    
    window.addEventListener('map-reset-view', handleResetView);
    return () => window.removeEventListener('map-reset-view', handleResetView);
  }, [validLocations]);

  // Update the event listener for location cards
/*   useEffect(() => {
    const handleLocationHover = (e: Event) => {
      const customEvent = e as CustomEvent;
      const locationId = customEvent.detail?.locationId;
      if (locationId) {
        setHoveredMarkerId(locationId);
        //setHoverSource('card');
      }
    };
    
    const handleLocationHoverEnd = () => {
      //if (hoverSource === 'card') {
        setHoveredMarkerId(null);
        //setHoverSource(null);
      //}
    };
    
    window.addEventListener('tripper-location-hover', handleLocationHover);
    window.addEventListener('tripper-location-hover-end', handleLocationHoverEnd);
    
    return () => {
      window.removeEventListener('tripper-location-hover', handleLocationHover);
      window.removeEventListener('tripper-location-hover-end', handleLocationHoverEnd);
    };
  }, [hoverSource, validLocations]); */

  // Find the useEffect that listens for the hover events
  useEffect(() => {
    const handleLocationHover = (e: Event) => {
      const customEvent = e as CustomEvent;
      const locationId = customEvent.detail?.locationId;
      if (locationId) {
        // Set hover marker ID (this part is already working - scales the marker)
        setHoveredMarkerId(locationId);
        
        // Find the corresponding location object to set hoveredLocation
        // This is what's missing - it's needed for the tooltip to show
        const hoveredLoc = validLocations.find(loc => loc.id === locationId);
        if (hoveredLoc) {
          setHoveredLocation(hoveredLoc); // This will make the tooltip appear
        }
      }
    };
    
    const handleLocationHoverEnd = () => {
      // Reset both states when hover ends
      setHoveredMarkerId(null);
      setHoveredLocation(null); // Clear the location to hide tooltip
    };
    
    window.addEventListener('tripper-location-hover', handleLocationHover);
    window.addEventListener('tripper-location-hover-end', handleLocationHoverEnd);
    
    return () => {
      window.removeEventListener('tripper-location-hover', handleLocationHover);
      window.removeEventListener('tripper-location-hover-end', handleLocationHoverEnd);
    };
  }, [validLocations]); // Add validLocations as dependency

  // Update this useEffect in MapPanel.tsx to set the hoveredLocation
  /* useEffect(() => {
    const handleLocationHover = (e: Event) => {
      const customEvent = e as CustomEvent;
      const locationId = customEvent.detail?.locationId;
      if (locationId) {
        // Set the hovered marker ID (this is already working)
        setHoveredMarkerId(locationId);
        
        // IMPORTANT: Also set the hoveredLocation to make the tooltip appear
        const hoveredLoc = validLocations.find(loc => loc.id === locationId);
        if (hoveredLoc) {
          setHoveredLocation(hoveredLoc);
        }
      }
    };
    
    const handleLocationHoverEnd = () => {
      setHoveredMarkerId(null);
      setHoveredLocation(null); // Clear the hoveredLocation to hide tooltip
    };
    
    window.addEventListener('tripper-location-hover', handleLocationHover);
    window.addEventListener('tripper-location-hover-end', handleLocationHoverEnd);
    
    return () => {
      window.removeEventListener('tripper-location-hover', handleLocationHover);
      window.removeEventListener('tripper-location-hover-end', handleLocationHoverEnd);
    };
  }, [validLocations]); // Need validLocations as a dependency */
  // Add this effect to log state changes for debugging
  /* useEffect(() => {
    console.log('[MapPanel] State change:', {
      showInfoCard,
      isClosing,
      hasSelectedLocation: !!selectedMarkerLocation,
      hasMarkerPosition: !!markerPosition
    });
  }, [showInfoCard, isClosing, selectedMarkerLocation, markerPosition]); */


  // Track map state changes
  useEffect(() => {
    if (locations.length > 0) {
      // Only update visible locations when they've actually changed
      // This will prevent duplicative saves
      mapStateService.updateVisibleLocations(
        locations.map(location => location.id)
      );
    }
  }, [locations]); // Only depends on locations array


  // Update this useEffect in MapPanel.tsx to handle location card clicks properly
  useEffect(() => {
    if (selectedLocation && 
        (!prevSelectedLocationRef.current || 
        prevSelectedLocationRef.current.id !== selectedLocation.id)) {
      //console.log('[MapPanel] Selected location updated from card click:', selectedLocation);
      
      // First, clear existing images immediately
      setPopupImages([]);
      
      // Set the selected marker location
      setSelectedMarkerLocation(selectedLocation);
      prevSelectedLocationRef.current = selectedLocation;
      
      // Calculate and set marker position
      if (mapRef.current) {
        const map = mapRef.current;
        const latLng = L.latLng(selectedLocation.position.lat, selectedLocation.position.lng);
        const point = map.latLngToContainerPoint(latLng);
        setMarkerPosition({ x: point.x, y: point.y });
      }
      
      // Show the info card
      setShowInfoCard(true);
      
      // Fetch images with force reload
      fetchPlaceImages(selectedLocation, true);
      
      // Optional: Fly to the location
      if (mapRef.current) {
        mapRef.current.flyTo(
          [selectedLocation.position.lat, selectedLocation.position.lng],
          15, // zoom level
          { duration: 1.5 } // animation duration in seconds
        );
      }
    }
  }, [selectedLocation]);

  // Add this effect to update marker scale when active or hover state changes
  /* useEffect(() => {
    // Update marker icons when active or hovered state changes
    Object.entries(markerRefs.current).forEach(([id, markerRef]) => {
      if (!markerRef || !markerRef._icon) return;
      
      const markerElement = markerRef._icon;
      const isActive = id === activeMarkerId;
      const isHovered = id === hoveredMarkerId;
      const isNewMarker = newMarkerIds.has(id);
      
      // Check if we're dealing with day-based locations
      const hasDays = validLocations.some(loc => loc.dayNumber !== undefined);
      
      // Calculate the appropriate scale based on state
      const scale = isActive ? 1.5 : isHovered ? 1.3 : isNewMarker ? 1.3 : hasDays ? 0.8 : 1;
      
      // Apply transformation directly
      markerElement.style.transform = `scale(${scale})`;
      markerElement.style.zIndex = isActive ? '1000' : isHovered ? '999' : '';
      markerElement.style.transition = 'transform 0.2s ease-out';
    });
  }, [activeMarkerId, hoveredMarkerId, newMarkerIds, validLocations]); */

  // Here's a fixed, safer version that won't make markers disappear
/*   useEffect(() => {
    // Only update the marker class names instead of directly manipulating styles
    Object.entries(markerRefs.current).forEach(([id, markerRef]) => {
      if (!markerRef || !markerRef._icon) return;
      
      const markerElement = markerRef._icon;
      const isActive = id === activeMarkerId;
      const isHovered = id === hoveredMarkerId;
      
      // Instead of directly changing transform, add/remove classes
      if (isActive) {
        markerElement.classList.add('marker-active');
      } else {
        markerElement.classList.remove('marker-active');
      }
      
      if (isHovered) {
        markerElement.classList.add('marker-hover');
      } else {
        markerElement.classList.remove('marker-hover');
      }
    });
  }, [activeMarkerId, hoveredMarkerId]); */

  // Update this useEffect in MapPanel.tsx that handles marker states
  useEffect(() => {
    // Loop through all markers and update their z-index and classes
    Object.entries(markerRefs.current).forEach(([id, markerRef]) => {
      if (!markerRef || !markerRef._icon) return;
      
      const markerElement = markerRef._icon;
      const isActive = id === activeMarkerId;
      const isHovered = id === hoveredMarkerId;
      
      // Add/remove classes for visual state
      if (isActive) {
        markerElement.classList.add('marker-active');
      } else {
        markerElement.classList.remove('marker-active');
      }
      
      if (isHovered) {
        markerElement.classList.add('marker-hover');
      } else {
        markerElement.classList.remove('marker-hover');
      }
      
      // IMPORTANT: Set explicit z-index based on state
      if (isActive) {
        markerElement.style.zIndex = '2000'; // Highest priority
      } else if (isHovered) {
        markerElement.style.zIndex = '1500'; // Second highest
      } else {
        // Reset to default - important to clear this when state changes
        markerElement.style.zIndex = '';
      }
    });
  }, [activeMarkerId, hoveredMarkerId]);

  // In MapPanel.tsx, add an effect to handle location changes
  useEffect(() => {
    // console.log('[MapPanel] Locations updated:', validLocations.length);
    
    // If a specific location is selected, ensure it has the correct appearance
    if (selectedLocation) {
      const locationInCollection = validLocations.find(
        loc => loc.id === selectedLocation.id
      );
      
      if (locationInCollection && locationInCollection.dayNumber !== selectedLocation.dayNumber) {
        // If the day assignment has changed, update the selected location
        setSelectedMarkerLocation(locationInCollection);
      }
    }
  }, [validLocations, selectedLocation]);

  // Add to MapPanel.tsx - Add this useEffect
  useEffect(() => {
    // Auto-select first location if there's only one
    if (validLocations.length === 1 && !selectedMarkerLocation && !isMapAnimating) {
      //console.log('[MapPanel] Auto-selecting single location');
      const location = validLocations[0];
      setSelectedMarkerLocation(location);
      
      // Get position for the card
      const position = getMarkerScreenPosition(location);
      if (position) {
        setMarkerPosition(position);
      }
      
      // Fetch images and notify parent after map is ready
      fetchPlaceImages(location);
      onLocationSelect(location);
      
      // Show info card after a short delay for animations
      setTimeout(() => {
        setShowInfoCard(true);
      }, 300);
    }
  }, [validLocations, selectedMarkerLocation, isMapAnimating]);


  useEffect(() => {
    // When locations change, track newly added markers
    const currentIds = new Set(markerRefs.current ? Object.keys(markerRefs.current) : []);
    const newIds = validLocations
      .map(loc => loc.id)
      .filter(id => !currentIds.has(id));
    
    if (newIds.length > 0) {
      // Add animation class after a brief delay
      setTimeout(() => {
        newIds.forEach(id => {
          const marker = markerRefs.current[id];
          if (marker) {
            // Use type assertion to access _icon
            const markerIcon = (marker as any)._icon;
            if (markerIcon) {
              markerIcon.classList.add('marker-pop');
              
              // Remove class after animation completes
              markerIcon.addEventListener('animationend', () => {
                markerIcon.classList.remove('marker-pop');
              }, { once: true });
            }
          }
        });
      }, 50);
      setNewMarkerIds(new Set(newIds));
      
      // Remove "new" status after animation completes
      setTimeout(() => {
        setNewMarkerIds(new Set());
      }, 1500); // Animation duration + small buffer
    }
  }, [validLocations]);

  // Add this effect back to MapPanel.tsx to properly track marker positions when the map moves
  // Insert this code as a new useEffect in the MapPanel component

  useEffect(() => {
    if (!mapRef.current || !selectedMarkerLocation) {
      /* console.log('[MapPanel] Map position tracking skipped - missing requirements:', {
        hasMapRef: !!mapRef.current,
        hasSelectedMarker: !!selectedMarkerLocation
      }); */
      return;
    }
    
    const map = mapRef.current;
    
    // Create a stable position update handler
    function updatePosition() {
      if (!selectedMarkerLocation) return;
      
      try {
        // console.log('[MapPanel] Updating marker position for:', selectedMarkerLocation.name);
        
        // Get the marker screen position
        const latLng = L.latLng(selectedMarkerLocation.position.lat, selectedMarkerLocation.position.lng);
        const mapContainer = map.getContainer();
        const mapRect = mapContainer.getBoundingClientRect();
        const point = map.latLngToContainerPoint(latLng);
        
        // Set the new position
        const newPosition = { x: point.x, y: point.y };
        // console.log('[MapPanel] New marker position:', newPosition);
        
        // Only update if position actually changed to avoid rendering loops
        setMarkerPosition(prev => {
          if (!prev || Math.abs(prev.x - newPosition.x) > 1 || Math.abs(prev.y - newPosition.y) > 1) {
            return newPosition;
          }
          return prev;
        });
      } catch (error) {
        // console.error('[MapPanel] Error updating marker position:', error);
      }
    }
    
    // Add event listeners for map movements
    console.log('[MapPanel] Setting up map movement tracking');
    map.on('move', updatePosition);
    map.on('moveend', updatePosition);
    map.on('zoom', updatePosition);
    map.on('zoomend', updatePosition);
    map.on('resize', updatePosition);
    
    // Initial update
    updatePosition();
    
    // Another update after a frame to ensure position is correct
    requestAnimationFrame(updatePosition);
    
    // Cleanup function
    return () => {
      console.log('[MapPanel] Removing map movement event listeners');
      map.off('move', updatePosition);
      map.off('moveend', updatePosition);
      map.off('zoom', updatePosition);
      map.off('zoomend', updatePosition);
      map.off('resize', updatePosition);
    };
  }, [selectedMarkerLocation, showInfoCard]);

  return (
    <div className="h-full relative" onClick={handleMapClick}>
      <MapContainer
        center={defaultCenter}
        zoom={defaultZoom}
        style={{ height: '100%', width: '100%' }}
        minZoom={defaultZoom} 
        ref={mapRef}
        scrollWheelZoom={true}
        zoomControl={false} // Disable default zoom controls
      >
        {tileLayer}
        {/* <SmoothZoomControl sensitivity={1.5} duration={400} /> */}
        {/* <MapControls
          locations={validLocations}
          onReset={() => {
            setShowInfoCard(false);
            setSelectedMarkerLocation(null);
            setMarkerPosition(null);
            onLocationSelect(null);
          }}
          chatPanelVisible={chatPanelVisible}
        /> */}
        <MapUpdater 
          locations={validLocations} 
          selectedLocation={selectedLocation}
          onAnimationComplete={(location) => {
            //console.log('[MapPanel] Map animation complete for:', location.name);
            // No need to manually set animation state to false here as we'll get it from the callback
            
            // Show the info card if we have a selected marker
            if (selectedMarkerLocation) {
              setShowInfoCard(true);
            }
          }}
          onAnimatingChange={(animating) => {
            // This callback will be called whenever animation state changes in MapUpdater
            setIsMapAnimating(animating);
          }}
        />
        {/* <ResetControl 
          locations={validLocations} 
          onReset={() => {
            setShowInfoCard(false);
            setSelectedMarkerLocation(null);
            setMarkerPosition(null);
            onLocationSelect(null);
          }}
          chatPanelVisible={chatPanelVisible} // Pass the prop
        /> */}
       {validLocations.map((location, index) => {
          // Declare isNewMarker at the top of the map callback
        const isNewMarker = newMarkerIds.has(location.id);
        // Check if we're dealing with day-based locations
        const hasDays = validLocations.some(loc => loc.dayNumber !== undefined);
        
        //console.log('[MapPanel] validLocations:', validLocations)
        

        let markerIcon;
        const isBlueMarker = !hasDays || 
          (location.dayNumber === undefined && COLOR_SEQUENCE[index % COLOR_SEQUENCE.length] === 'blue');
        
        const isActive = activeMarkerId === location.id;
        const isHovered = hoveredMarkerId === location.id;
       
        // Update the scale values to be more pronounced and add transition
        const scale = isActive ? 1.5 : isHovered ? 1.3 : hasDays ? 1.2 : 1;
        //const scale = isActive ? 1.5 : isHovered ? 1.3 : hasDays ? 0.8 : 1;

        if (hasDays) {
          // Case 1: Day-based itinerary with color coding
          const dayNumber = location.dayNumber;
          const colorKey = dayNumber 
            ? COLOR_SEQUENCE[(dayNumber - 1) % COLOR_SEQUENCE.length]
            : 'blue';
          
          // Inside your map function where you create markers
          //const isNewMarker = newMarkerIds.has(location.id);
          // Add animation state to scale calculation
          const scale = isActive ? 1.5 : isHovered ? 1.3 : isNewMarker ? 1 : hasDays ? 1.2 : 1;
          // Make newly added markers animated
          const shouldAnimate = isNewMarker || colorKey === 'blue';

          console.log("[MAP PANEL] Marker Scale - hasDays ", scale); 
          markerIcon = createPin({ 
            number: index + 1, 
            color: colorKey,
            scale: scale,
            animated: colorKey === 'blue',  
            id: location.id
          });

        } else {
          // Case 2: Multiple locations without days (all blue with numbers)
          console.log("[MAP PANEL] Marker Scale - noDays ", scale); 

          markerIcon = locations.length > 1 
            ? createPin({ 
                number: index + 1, 
                color: 'blue', 
                scale: scale,
                animated: true,
                id: location.id
              })
            : createPin({ 
                color: 'blue', 
                scale: scale,
                animated: true,
                id: location.id
              });
        }
          
        return (
          <Marker
            key={location.id}
            position={[location.position.lat, location.position.lng]}
            icon={markerIcon}
            zIndexOffset={(1000 + (index * 10))} // Higher numbers = higher stack order
            ref={(ref) => {
              if (ref) {
                markerRefs.current[location.id] = ref;
                
                // For new markers
                if (newMarkerIds.has(location.id)) {
                  // Wait for next frame
                  requestAnimationFrame(() => {
                    const icon = (ref as any)._icon;
                    if (icon) {
                      icon.classList.add('marker-pop');
                    }
                  });
                }
              }
            }}
            eventHandlers={{
              click: (event) => {
                // Add data attribute to marker
                const markerElement = event.target._icon;
                if (markerElement) {
                  markerElement.setAttribute('data-marker-id', location.id);
                  if (isNewMarker) {
                    markerElement.setAttribute('data-new', 'true');
                  }
                }
                
                // Set active marker
                setActiveMarkerId(location.id);
                
                // Clear hover state
                setHoveredMarkerId(null);
                
                // Handle click
                handleMarkerClick(location, event);
              },
              // Add these mouse event handlers for hover state
              mouseover: () => {
                // Don't set hover if already active
                if (activeMarkerId !== location.id) {
                  setHoveredMarkerId(location.id);
                  //setHoverSource('map');
                  setHoveredLocation(location);
                }
              },
              mouseout: () => {
                //if (hoverSource === 'map') {
                  setHoveredMarkerId(null);
                  //setHoverSource(null);
                  setHoveredLocation(null);
                //}
              }
            }}
          />
          );
        })}
      </MapContainer>
      
      {isProcessingLocation && (
        <div className="absolute inset-0 bg-white/30 backdrop-blur-[1px] z-[60] pointer-events-none flex items-center justify-center">
          <div className="bg-white/90 rounded-lg px-4 py-2 shadow-lg">
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 border-2 border-gray-600 border-t-transparent rounded-full animate-spin" />
              <span className="text-gray-600 font-medium">Discovering locations...</span>
            </div>
          </div>
        </div>
      )}
      {/* <MarkerTooltip
        locationName={hoveredLocation?.name ?? null}
        position={tooltipPosition}
        isVisible={!!hoveredLocation}// && hoverSource === 'map' // && !showInfoCard
      /> */}
      <MarkerTooltip
          locationName={hoveredLocation?.name ?? null}
          position={tooltipPosition}
          isVisible={!!hoveredLocation}
          dayNumber={hoveredLocation && 'dayNumber' in hoveredLocation ? 
                    (hoveredLocation as any).dayNumber : undefined}
        />
      <MapInfoCard 
        location={showInfoCard ? selectedMarkerLocation : null}
        onClose={handleCloseInfoCard}
        markerPosition={markerPosition}
        images={locationImages}
        onImagesUpdate={handleImagesUpdate}
        isClosing={isClosing}
      />
      {/* <MapInfoCard 
        location={showInfoCard ? selectedMarkerLocation : null}
        images={locationImages}
        onImagesUpdate={handleImagesUpdate}
        onClose={handleCloseInfoCard}
        markerPosition={markerPosition} */}
         {/* images={popupImages} */}
      {/* /> */}
    </div>
  );
};

// location={selectedLocation}
// location={selectedLocation}
// images={locationImages}
// onImagesUpdate={handleImagesUpdate}